import { render, staticRenderFns } from "./TwinKleEffect.vue?vue&type=template&id=1a5f0b69&scoped=true&"
import script from "./TwinKleEffect.vue?vue&type=script&lang=js&"
export * from "./TwinKleEffect.vue?vue&type=script&lang=js&"
import style0 from "./TwinKleEffect.vue?vue&type=style&index=0&id=1a5f0b69&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f0b69",
  null
  
)

export default component.exports